// extracted by mini-css-extract-plugin
export var box = "_51-0";
export var check = "_51-1";
export var checkboxButton = "_51-6";
export var checkboxGroup = "_51-5";
export var disabled = "_51-7";
export var ghost = "_51-9";
export var input = "_51-2";
export var label = "_51-4";
export var normal = "_51-8";
export var uncheck = "_51-3";